import { COVERAGE_CITIES } from '@/mocks/home';
import Bubbles from './Bubbles';

const COLUMNS = [
  COVERAGE_CITIES.slice(0, 4),
  COVERAGE_CITIES.slice(4, 8),
  COVERAGE_CITIES.slice(8, 12),
];

export default function CoverageArea() {
  return (
    <section className="relative overflow-hidden bg-secondary-50 py-16 md:py-24">
      <Bubbles />
      <div className="relative mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="text-center">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-accent-500 text-background-50">
            <i className="ri-map-pin-2-fill text-3xl"></i>
          </span>
          <h2 className="mt-5 font-heading text-3xl font-extrabold text-primary-800 md:text-4xl">
            Our Coverage Area
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm text-foreground-600 md:text-base">
            We proudly serve the following cities across Southwest Florida. Not sure if we reach you? Give us a call.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-x-8 gap-y-3 rounded-lg border border-background-200 bg-background-50 p-8 sm:grid-cols-3 md:p-10">
          {COLUMNS.map((col, ci) => (
            <ul key={ci} className="space-y-3">
              {col.map((city) => (
                <li key={city} className="flex items-center gap-2 text-sm font-medium text-foreground-700">
                  <i className="ri-checkbox-circle-fill text-accent-500"></i>
                  {city}
                </li>
              ))}
            </ul>
          ))}
        </div>
      </div>
    </section>
  );
}